var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{attrs:{"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event)}}},[(!_vm.loading)?_vm._t("default"):[_vm._v(_vm._s(_vm.__('Loading...')))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }